import axios from 'axios';
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

export const REQUEST_ORG_UNIT_HIERARCHY = 'REQUEST_ORG_UNIT_HIERARCHY';
export function requestOrgUNitHierarchy() {
    return {
        type: REQUEST_ORG_UNIT_HIERARCHY
    }
}

export const FETCH_ORG_UNIT_HIERARCHY_SUCCESS = 'FETCH_ORG_UNIT_HIERARCHY_SUCCESS';
export function fetchOrgUnitHierarchySuccess(orgUnitHierarchy) {
    return {
        type: FETCH_ORG_UNIT_HIERARCHY_SUCCESS,
        orgUnitHierarchy
    }
}

export const FETCH_ORG_UNIT_HIERARCHY_FAIL = 'FETCH_ORG_UNIT_HIERARCHY_FAIL';
export function fetchOrgUnitHierarchyFail() {
    return {
        type: FETCH_ORG_UNIT_HIERARCHY_FAIL
    }
}

export function fetchOrgUnitHierarchy() {
    return function (dispatch) {
        dispatch(requestOrgUNitHierarchy());

        return axios.get('/organizational-units/hierarchy')
        .then(
            response => dispatch(fetchOrgUnitHierarchySuccess(response.data)),
            error => dispatch(fetchOrgUnitHierarchyFail()));
    }
}

export const REQUEST_SELECTED_ORG_UNIT_DETAILS = 'REQUEST_SELECTED_ORG_UNIT_DETAILS';
export function requestSelectedOrgUnitDetails() {
    return {
        type: REQUEST_SELECTED_ORG_UNIT_DETAILS
    }
}

export const FETCH_SELECTED_ORG_UNIT_DETAILS_SUCCESS = 'FETCH_SELECTED_ORG_UNIT_DETAILS_SUCCESS';
export function fetchSelectedOrgUnitDetailsSuccess(orgUnitDetails) {
    return {
        type: FETCH_SELECTED_ORG_UNIT_DETAILS_SUCCESS,
        orgUnitDetails
    }
}

export const FETCH_SELECTED_ORG_UNIT_DETAILS_FAIL = 'FETCH_SELECTED_ORG_UNIT_DETAILS_FAIL';
export function fetchSelectedOrgUnitDetailsFail() {
    return {
        type: FETCH_SELECTED_ORG_UNIT_DETAILS_FAIL
    }
}

export function fetchSelectedOrgUnitDetails(id) {
    return function (dispatch) {
        dispatch(requestSelectedOrgUnitDetails());

        return axios.get(`/organizational-units/${id}/detailed`)
        .then(
            response => dispatch(fetchSelectedOrgUnitDetailsSuccess(response.data)),
            error => dispatch(fetchSelectedOrgUnitDetailsFail()));
    }
}

export const TOGGLE_SHOW_ADD_PARENT_ORG_UNIT = 'TOGGLE_SHOW_ADD_PARENT_ORG_UNIT';
export function toggleShowAddParentOrgUnit() {
    return {
        type: TOGGLE_SHOW_ADD_PARENT_ORG_UNIT
    }
}

export const SELECT_PARENT_ORG_UNIT = 'SELECT_PARENT_ORG_UNIT';
export function selectParentOrgUnit(parentOrgUnitIdToAdd) {
    return {
        type: SELECT_PARENT_ORG_UNIT,
        parentOrgUnitIdToAdd
    }
}

export const REQUEST_ORG_UNITS = 'REQUEST_ORG_UNITS';
export function requestOrgUnits() {
    return {
        type: REQUEST_ORG_UNITS
    }
}

export const FETCH_ORG_UNITS_SUCCESS = 'FETCH_ORG_UNITS_SUCCESS';
export function fetchOrgUnitsSuccess(orgUnits) {
    return {
        type: FETCH_ORG_UNITS_SUCCESS,
        orgUnits
    }
}

export const FETCH_ORG_UNITS_FAIL = 'FETCH_ORG_UNITS_FAIL';
export function fetchOrgUnitsFail() {
    return {
        type: FETCH_ORG_UNITS_FAIL
    }
}

export function fetchOrgUnits() {
    return function (dispatch) {
        dispatch(requestOrgUnits());

        return axios.get('/organizational-units')
        .then(
            response => dispatch(fetchOrgUnitsSuccess(response.data)),
            error => dispatch(fetchOrgUnitsFail()));
    }
}

export const SEND_ADD_ORG_UNIT_PARENT = 'SEND_ADD_ORG_UNIT_PARENT';
export function sendAddOrgUnitParent() {
    return {
        type: SEND_ADD_ORG_UNIT_PARENT
    }
}

export const ADD_ORG_UNIT_PARENT_SUCCESS = 'ADD_ORG_UNIT_PARENT_SUCCESS';
export function addOrgUnitParentSuccess() {
    return {
        type: ADD_ORG_UNIT_PARENT_SUCCESS
    }
}

export const ADD_ORG_UNIT_PARENT_FAIL = 'ADD_ORG_UNIT_PARENT_FAIL';
export function addOrgUnitParentFail() {
    return {
        type: ADD_ORG_UNIT_PARENT_FAIL
    }
}

export function addOrgUnitParent(orgUnitId, parentOrgUnitId) {
    return function (dispatch) {
        dispatch(sendAddOrgUnitParent());

        return axios.put(`/organizational-units/${orgUnitId}/parents/${parentOrgUnitId}`)
        .then(
            response => {
                dispatch(addOrgUnitParentSuccess());
                dispatch(fetchSelectedOrgUnitDetails(orgUnitId));
                dispatch(fetchOrgUnitHierarchy());
            },
            error => dispatch(addOrgUnitParentFail())
        );
    }
}

export const TOGGLE_SHOW_ADD_ORG_UNIT_TYPE = 'TOGGLE_SHOW_ADD_ORG_UNIT_TYPE';
export function toggleShowAddOrgUnitType() {
    return {
        type: TOGGLE_SHOW_ADD_ORG_UNIT_TYPE
    }
}

export const REQUEST_ORG_UNIT_TYPES = 'REQUEST_ORG_UNIT_TYPES';
export function requestOrgUnitTypes() {
    return {
        type: REQUEST_ORG_UNIT_TYPES
    }
}

export const FETCH_ORG_UNIT_TYPES_SUCCESS = 'FETCH_ORG_UNIT_TYPES_SUCCESS';
export function fetchOrgUnitTypesSuccess(orgUnitTypes) {
    return {
        type: FETCH_ORG_UNIT_TYPES_SUCCESS,
        orgUnitTypes
    }
}

export const FETCH_ORG_UNIT_TYPES_FAIL = 'FETCH_ORG_UNIT_TYPES_FAIL';
export function fetchOrgUnitTypesFail() {
    return {
        type: FETCH_ORG_UNIT_TYPES_FAIL
    }
}

export function fetchOrgUnitTypes() {
    return function (dispatch) {
        dispatch(requestOrgUnitTypes());

        return axios.get('/organizational-unit-types')
        .then(
            response => dispatch(fetchOrgUnitTypesSuccess(response.data)),
            error => dispatch(fetchOrgUnitTypesFail()));
    }
}

export const SELECT_ORG_UNIT_TYPE = 'SELECT_ORG_UNIT_TYPE';
export function selectOrgUnitType(orgUnitTypeIdToAdd) {
    return {
        type: SELECT_ORG_UNIT_TYPE,
        orgUnitTypeIdToAdd
    }
}

export const SEND_ADD_ORG_UNIT_TYPE = 'SEND_ADD_ORG_UNIT_TYPE';
export function sendAddOrgUnitType() {
    return {
        type: SEND_ADD_ORG_UNIT_TYPE
    }
}

export const ADD_ORG_UNIT_TYPE_SUCCESS = 'ADD_ORG_UNIT_TYPE_SUCCESS';
export function addOrgUnitTypeSuccess() {
    return {
        type: ADD_ORG_UNIT_TYPE_SUCCESS
    }
}

export const ADD_ORG_UNIT_TYPE_FAIL = 'ADD_ORG_UNIT_TYPE_FAIL';
export function addOrgUnitTypeFail() {
    return {
        type: ADD_ORG_UNIT_TYPE_FAIL
    }
}

export function addOrgUnitType(orgUnitId, orgUnitType) {
    return function (dispatch) {
        dispatch(sendAddOrgUnitType());

        return axios.post(`/organizational-units/${orgUnitId}/types`, orgUnitType)
        .then(
            response => {
                dispatch(addOrgUnitTypeSuccess());
                dispatch(fetchSelectedOrgUnitDetails(orgUnitId));
            },
            error => dispatch(addOrgUnitTypeFail())
        );
    }
}

export const TOGGLE_SHOW_ADD_ORG_UNIT_STAFF = 'TOGGLE_SHOW_ADD_ORG_UNIT_STAFF';
export function toggleShowAddOrgUnitStaff() {
    return {
        type: TOGGLE_SHOW_ADD_ORG_UNIT_STAFF
    }
}

export const REQUEST_ORG_UNIT_POSITIONS = 'REQUEST_ORG_UNIT_POSITIONS';
export function requestOrgUnitPositions() {
    return {
        type: REQUEST_ORG_UNIT_POSITIONS
    }
}

export const FETCH_ORG_UNIT_POSITIONS_SUCCESS = 'FETCH_ORG_UNIT_POSITIONS_SUCCESS';
export function fetchOrgUnitPositionsSuccess(orgUnitPositions) {
    return {
        type: FETCH_ORG_UNIT_POSITIONS_SUCCESS,
        orgUnitPositions
    }
}

export const FETCH_ORG_UNIT_POSITIONS_FAIL = 'FETCH_ORG_UNIT_POSITIONS_FAIL';
export function fetchOrgUnitPositionsFail() {
    return {
        type: FETCH_ORG_UNIT_POSITIONS_FAIL
    }
}

export function fetchOrgUnitPositions(orgUnitId) {
    return function (dispatch) {
        dispatch(requestOrgUnitPositions());

        return axios.get(`/organizational-units/${orgUnitId}/positions`)
        .then(
            response => dispatch(fetchOrgUnitPositionsSuccess(response.data)),
            error => dispatch(fetchOrgUnitPositionsFail()));
    }
}

export const REQUEST_ORG_UNIT_EMPLOYEES = 'REQUEST_ORG_UNIT_EMPLOYEES';
export function requestOrgUnitEmployees() {
    return {
        type: REQUEST_ORG_UNIT_EMPLOYEES
    }
}

export const FETCH_ORG_UNIT_EMPLOYEES_SUCCESS = 'FETCH_ORG_UNIT_EMPLOYEES_SUCCESS';
export function fetchOrgUnitEmployeesSuccess(orgUnitEmployees) {
    return {
        type: FETCH_ORG_UNIT_EMPLOYEES_SUCCESS,
        orgUnitEmployees
    }
}

export const FETCH_ORG_UNIT_EMPLOYEES_FAIL = 'FETCH_ORG_UNIT_EMPLOYEES_FAIL';
export function fetchOrgUnitEmployeesFail() {
    return {
        type: FETCH_ORG_UNIT_EMPLOYEES_FAIL
    }
}

export function fetchOrgUnitEmployees() {
    return function (dispatch) {
        dispatch(requestOrgUnitEmployees());

        return axios.get('/employees')
        .then(
            response => dispatch(fetchOrgUnitEmployeesSuccess(response.data)),
            error => dispatch(fetchOrgUnitEmployeesFail()));
    }
}

export const SELECT_ORG_UNIT_STAFF_POSITION = 'SELECT_ORG_UNIT_STAFF_POSITION';
export function selectOrgUnitStaffPosition(orgUnitPositionIdToAdd) {
    return {
        type: SELECT_ORG_UNIT_STAFF_POSITION,
        orgUnitPositionIdToAdd
    }
}

export const SELECT_ORG_UNIT_STAFF_EMPLOYEE = 'SELECT_ORG_UNIT_STAFF_EMPLOYEE';
export function selectOrgUnitStaffEmployee(orgUnitEmployeeIdToAdd) {
    return {
        type: SELECT_ORG_UNIT_STAFF_EMPLOYEE,
        orgUnitEmployeeIdToAdd
    }
}

export const SEND_ADD_ORG_UNIT_STAFF = 'SEND_ADD_ORG_UNIT_STAFF';
export function sendAddOrgUnitStaff() {
    return {
        type: SEND_ADD_ORG_UNIT_STAFF
    }
}

export const ADD_ORG_UNIT_STAFF_SUCCESS = 'ADD_ORG_UNIT_STAFF_SUCCESS';
export function addOrgUnitStaffSuccess() {
    return {
        type: ADD_ORG_UNIT_STAFF_SUCCESS
    }
}

export const ADD_ORG_UNIT_STAFF_FAIL = 'ADD_ORG_UNIT_STAFF_FAIL';
export function addOrgUnitStaffFail() {
    return {
        type: ADD_ORG_UNIT_STAFF_FAIL
    }
}

export function addOrgUnitStaff(orgUnitId, orgUnitEmployeeIdToAdd, position) {
    return function (dispatch) {
        dispatch(sendAddOrgUnitStaff());

        return axios.put(`/organizational-units/${orgUnitId}/staff/${orgUnitEmployeeIdToAdd}`, position )
        .then(
            response => {
                dispatch(addOrgUnitStaffSuccess());
                dispatch(fetchSelectedOrgUnitDetails(orgUnitId));
            },
            error => dispatch(addOrgUnitStaffFail())
        );
    }
}

export const TOGGLE_SHOW_ADD_ORG_UNIT_CONTACT = 'TOGGLE_SHOW_ADD_ORG_UNIT_CONTACT';
export function toggleShowAddOrgUnitContact() {
    return {
        type: TOGGLE_SHOW_ADD_ORG_UNIT_CONTACT
    }
}

export const REQUEST_CONTACT_TYPES = 'REQUEST_CONTACT_TYPES';
export function requestContactTypes() {
    return {
        type: REQUEST_CONTACT_TYPES
    }
}

export const FETCH_CONTACT_TYPES_SUCCESS = 'FETCH_CONTACT_TYPES_SUCCESS';
export function fetchContactTypesSuccess(contactTypes) {
    return {
        type: FETCH_CONTACT_TYPES_SUCCESS,
        contactTypes
    }
}

export const FETCH_CONTACT_TYPES_FAIL = 'FETCH_CONTACT_TYPES_FAIL';
export function fetchContactTypesFail() {
    return {
        type: FETCH_CONTACT_TYPES_FAIL
    }
}

export function fetchContactTypes() {
    return function (dispatch) {
        dispatch(requestContactTypes());

        return axios.get('/contact-types')
        .then(
            response => dispatch(fetchContactTypesSuccess(response.data)),
            error => dispatch(fetchContactTypesFail()));
    }
}

export const SEND_ADD_ORG_UNIT_CONTACT = 'SEND_ADD_ORG_UNIT_CONTACT';
export function sendAddOrgUnitContact() {
    return {
        type: SEND_ADD_ORG_UNIT_CONTACT
    }
}

export const ADD_ORG_UNIT_CONTACT_SUCCESS = 'ADD_ORG_UNIT_CONTACT_SUCCESS';
export function addOrgUnitContactSuccess() {
    return {
        type: ADD_ORG_UNIT_CONTACT_SUCCESS
    }
}

export const ADD_ORG_UNIT_CONTACT_FAIL = 'ADD_ORG_UNIT_CONTACT_FAIL';
export function addOrgUnitContactFail() {
    return {
        type: ADD_ORG_UNIT_CONTACT_FAIL
    }
}

export function addOrgUnitContact(orgUnitId, orgUnitContact) {
    return function (dispatch) {
        dispatch(sendAddOrgUnitContact());

        return axios.post(`/organizational-units/${orgUnitId}/contacts`, orgUnitContact)
        .then(
            response => {
                dispatch(addOrgUnitContactSuccess());
                dispatch(fetchSelectedOrgUnitDetails(orgUnitId));
            },
            error => dispatch(addOrgUnitContactFail())
        );
    }
}

export const PLACE_LKPS_LOADED = 'PLACE_LKPS_LOADED';
export const PLACE_LKPS_FAILED = 'PLACE_LKPS_FAILED';
export const PLACE_LKPS_LOADING = 'PLACE_LKPS_LOADING';



// WEBPACK FOOTER //
// ./src/reduxFiles/actionTypes.js